import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';

export const DispatchOffice = ({ ...restProps }) => {
    const { data, isLoading } = useQuery({
        queryKey: ['dispatchOffices'],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.dispatchLocations()),
    });

    return (
        <ValidatedSelect
            id="dispatchOfficeLocationId"
            name="dispatchOfficeLocationId"
            options={data}
            label="Dispatch Location"
            isLoading={isLoading}
            {...restProps}
        />
    );
};